<li class="toggle-omemo fa 
        {[ if (!o.omemo_supported) { ]} disabled {[ } ]}
        {[ if (o.omemo_active) { ]} fa-lock {[ } else { ]} fa-unlock {[ } ]}"
    title="{{{o.__('Messages are being sent in plaintext')}}}"></li>
